import React from 'react';
import { ButtonGroup, Button, FileUploadButton } from 'decap-cms-ui-next';
import { jsx as ___EmotionJSX } from "@emotion/react";
function MediaControls({
  isDialog,
  onSelect,
  hasSelection,
  selectedButtonLabel,
  onDelete,
  deleteEnabled,
  deleteButtonLabel,
  onUpload,
  uploadEnabled,
  uploadButtonLabel,
  imagesOnly
}) {
  return ___EmotionJSX(ButtonGroup, null, isDialog && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
    type: "success",
    primary: true,
    onClick: onSelect,
    disabled: !hasSelection,
    icon: "check"
  }, selectedButtonLabel)), ___EmotionJSX(FileUploadButton, {
    label: uploadButtonLabel,
    accept: imagesOnly ? 'image/*' : '*/*',
    onChange: onUpload,
    disabled: !uploadEnabled
  }));
}
export default MediaControls;